var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_56099",
    "data-name": "Group 56099",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.409,
    height: 20.393,
    viewBox: "0 0 13.409 20.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M7.22,16.8v2.575h3.61a.51.51,0,1,1,0,1.02H2.579a.51.51,0,1,1,0-1.02h3.61V16.8A6.67,6.67,0,0,1,0,10.2a.516.516,0,0,1,1.031,0,5.673,5.673,0,0,0,11.346,0,.516.516,0,0,1,1.031,0A6.652,6.652,0,0,1,7.22,16.8ZM10.572,3.824V10.2a3.868,3.868,0,0,1-7.736,0V3.824a3.868,3.868,0,0,1,7.736,0Zm-1.031,0a2.837,2.837,0,0,0-5.673,0V10.2a2.837,2.837,0,0,0,5.673,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audio-on.d724f449c4debe94edf709b3a69fbe3a.svg";
export { ForwardRef as ReactComponent };